import request, { extend } from 'umi-request';
import api from '@/services/api/index';

import commonSetting from '@/config/commonSetting';
import commonHelper from '@/utils/commonHelper';
import Cookies from 'js-cookie';
let isRefreshing = false // 是否正在刷新
const subscribers = [] // 重试队列，每一项将是一个待执行的函数形式

const addSubscriber = listener => subscribers.push(listener)

// 执行被缓存等待的接口事件
const notifySubscriber = (newToken = '') => {
  subscribers.forEach(callback => callback(newToken))
  subscribers.length = 0
}

// 刷新 token 请求
const refreshTokenRequest = async () => {
  const refreshToken  = window.localStorage.getItem('refreshToken')
  const accessToken  = window.localStorage.getItem('accessToken')
  try {
    const res = await api.authController.authTokenRefreshUsingPOST({refreshToken, accessToken})
    if(res.code === 0){
      localStorage.setItem('accessToken', res.data.value);
      notifySubscriber(res.data.value)
    }else { //token失效
     // message.info('请重新登录')
      localStorage.setItem('accessToken','')
      localStorage.setItem('openId','')
      localStorage.setItem('refreshToken','')
      localStorage.setItem('wxId','')
      commonHelper.redirectWxAuthorizationUrl(location.pathname, commonSetting.PRODUCT_TYPE)
    }

  } catch (e) {
    console.error('请求刷新 token 失败', e)
    localStorage.setItem('accessToken','')
    localStorage.setItem('openId','')
    localStorage.setItem('refreshToken','')
    localStorage.setItem('wxId','')
   commonHelper.redirectWxAuthorizationUrl(location.pathname, commonSetting.PRODUCT_TYPE)
  }
  isRefreshing = false
}

// 判断如何响应
function checkStatus(response, options) {
  const { url } = response
  const refreshToken  = window.localStorage.getItem('refreshToken')
  if(refreshToken){
    if (!isRefreshing ) {
      isRefreshing = true
      refreshTokenRequest()
    }
  }else {
    //message.info('请重新登录')
    localStorage.setItem('accessToken','')
    localStorage.setItem('openId','')
    localStorage.setItem('refreshToken','')
    localStorage.setItem('wxId','')
   // commonHelper.redirectWxAuthorizationUrl(commonSetting.ACCOUNT_TYPE,location.pathname, commonSetting.PRODUCT_TYPE)
    return
  }


  // 正在刷新 token，返回一个未执行 resolve 的 promise
  return new Promise(resolve => {
    addSubscriber(newToken => {
      const newOptions = {
        ...options,
        prefix: '',
        params: {},
        headers: {
          Authorization: 'Bearer ' + newToken
        }
      }
      resolve(request(url, newOptions))
    })
  })
}

const requestInstance = extend({
    prefix: commonSetting.BASE_URL,
    timeout: 10000,
    headers: {
        mode:"cors",
    },
    errorHandler: (error) => {
        //  debugger
        throw error;
    },
})
requestInstance.interceptors.request.use(
    (url, options) => {
        if(localStorage.getItem('accessToken')){
            options.headers.Authorization = 'Bearer ' + localStorage.getItem('accessToken')
        }
        if(ENV !== 'prod'){ // 开发环境
            const env = Cookies.get('env');
            if(options.mock){
                url = commonSetting.MOCK_URL + options.url;
            }else {
                url = commonSetting.BASE_URL + options.url;
            }
            if(env){
                options.headers.env = env
            }
        }

        if(options.noCache){
            url = url +  (url.includes('?') ? 't=' : '?t=') + new Date().getTime();
        }
        return {
            url : url,
            options: { ...options},
        };
    }, { global: false }
);
/**
 * 响应拦截
 */
requestInstance.interceptors.response.use(
    // @ts-ignore
    async (response, options) => {
        let data;
        try {
             data = await response.clone().json();
            console.log(data)
           if(data.code === 81071002){
            debugger
                commonHelper.browserHistory.replace('/no-access')
                history.go()

            }
        }catch (e) {

        }


        if(response.status == 503){
            //message.error('服务器错误')
        }else if([400].includes(response.status)){
            // message.error(`请求错误：错误码${response.status}  traceid:${response.headers.get("x-b3-traceid")}`)
            console.log(`请求错误：错误码${response.status}  traceid:${response.headers.get("x-b3-traceid")}`)
        }else if([401, 403].includes(response.status)) {
            return checkStatus(response, options)
        }
        return response
    }, { global: false }
);
export default requestInstance
